<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment'

   export default {
      page: {
         title: "Schedules",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Schedules",
            items: [
               {
                  text: "Doctors",
                  href: "/doctors",
               },                
               
               {
                  text: "Schedules",
                  active: true,
               },                     
            ],

            clinic: {
               duration: '',
               fees:'',
               commission: '',
            },

            clinic_consultation: [
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },
               { day: [] },

            ],
            clinic_consultation_checked: false,
            
            consultation: {
               address: '',
               clinic_id: '',
               commision: '',
               consultation_fee: '',
               consultation_type: '',
               duration_id: '',
               latitude: '',
               longitude: '',
               location: '',
               place: '',
            },
            pin_no: "",

            start: '',
            end: '',
            day: null,
            type: '',
            set_time:'',
            hour:'',
            minutes:'',
            time_name: '',
            doctor_id:'',
            duration_id: '',
            consultation_fee: '',
            consultation_type: '',
            token_type: '',
            reserved: 2,
            clinic_schedules: [],
            clinic_durations: [],
            sessions: {},
            duration: '',
            durations: [],
            clinic_del_session_ids: [],
            clinic_fees: '',

            master_sessions: [],
            master_session_id: '',
            master_session_value: '',
            masterStart : '',
            masterEnd: '', 
            session_name:'',

            

            home_location: '',
            home_marker: { position: { lat: null, lng: null } },
            home_center: { lat: null, lng: null },
            home_current_place: null,

            home_mapOptions: {
               disableDefaultUI: true,
            },

            errors: {},
            loading: false,

         };
      },
      mounted() {
         if(!this.$route.params.id){
            this.clearSession();
         }
      },

      watch: {
         start() {
         this.start = this.start.split(":").slice(0, 2).join(":");
         },
         end() {
         this.end = this.end.split(":").slice(0, 2).join(":");
         },
         duration() {
         this.duration = this.duration.split(":").slice(0, 2).join(":");
         },
      },


      created(){
         this.fetchShedules();
          this.fetchMasterSessions();
      },

      methods: {

         fetchShedules(page_url = null){

            this.getToken();
            let url = "clinic/doctor/doctorSchedule?id=" + this.$route.params.id;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  // console.log(responseData);
                  if(responseData){
                  this.clinic_schedules = responseData.schedules;

                  //console.log(this.clinic_schedules);

                        if(this.clinic_schedules) {
                           this.clinic_consultation_checked = true;
                           this.clinic_durations = this.durations;

                           if(this.clinic_schedules.length) {
                              this.setConsultations();
                              this.clinic_durations = this.clinic_schedules.duration;
                              //console.log(this.clinic_durations);
                              this.clinic_fees = this.clinic_schedules[0].consultation_fee;

                           }
                        } else {
                           this.clinic_schedules = this.consultation;
                           this.clinic_durations = this.active_durations;
                        }  
                        
                  }

                  
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                        console.log(error.response);

                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                     console.log(error);

                  }
            })
            .finally(() => (this.loading = false));


         },

          fetchMasterSessions() {
            let url = "api/admin/doctors/getMasterSessions?doctor_id=" + this.$route.params.id;
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.master_sessions = responseData.sessions;
                     
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         
         SetTimeRange() {
            if (this.master_session_value) {
                  let masterStart = this.master_session_value.master_start;
                  let masterEnd = this.master_session_value.master_end;

                  // Set default start and end within range
                  this.masterStart = masterStart;
                  this.masterEnd = masterEnd;
                  this.start = masterStart;
                  this.end = masterEnd;
                  this.master_session_id = this.master_session_value.id;
                  this.session_name = this.master_session_value.session_name;

            }
         },

         addClinicSchedule() {
            
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "clinic/doctor/addDoctorScheduleNew";  
       
            let formData = new FormData();

            formData.append("doctor_id", this.$route.params.id); 
            // formData.append("consultation_duration", this.clinic.duration_id); 
            // formData.append("consultation_fee", this.clinic.consultation_fee); 

            // formData.append("clinic_id", this.clinic.clinic_id); 

            formData.append('schedules', JSON.stringify(this.clinic_schedules));
            formData.append('consultation_fee', this.clinic_fees);
            formData.append('del_session_ids', JSON.stringify(this.clinic_del_session_ids));
            
            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  //this.clearForm();
                  this.$router.push({ name: 'doctors'});
               })
               .catch((error) => {
                  console.log(error.response);
                  if (error.response) {
                     if (error.response.data.message) {
                        if(error.response.status == 422) {
                           this.errors = error.response.data.message;
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },   
         
         goBack() {
            if (this.$route.params.from === 'profile') {
               // alert(this.$route.params.id);

               // If the user came from the profile, redirect them back to the profile with the doctor ID
               this.$router.push({ name: 'doctors.details', params: { id: this.$route.params.id } });
            } else {
               // alert(this.$route.params.from);

               // Otherwise, go back in history
               this.$router.go(-1);
            }
         },



         getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },

         setTime(){
            this.set_time = this.duration;
            this.hour = this.set_time.split(':')[0];
            this.minutes = this.set_time.split(':')[1];
            this.time_name = this.hour+' Hour '+ this.minutes +' minutes ';
            return  this.time_name;
         },

         setConsultations() {
            var sessions;
            var consultation = [
                { day: [] },
                { day: [] },
                { day: [] },
                { day: [] },
                { day: [] },
                { day: [] },
                { day: [] },
            ];
            var schedules = [];

            sessions = this.clinic_schedules;
            //console.log('sessions:', sessions);

            sessions.forEach(obj => {
                var session = {};
                session.start = moment(obj.start_time, 'HH:mm:ss').format('h:mm A');
                session.end = moment(obj.end_time, 'HH:mm:ss').format('h:mm A');
                session.session_id = obj.doctor_schedule_session_id;
                session.day = obj.day_id;
                session.duration = obj.duration;
                session.token_type = obj.token_type;
                session.doctor_id = obj.doctor_id;
                session.consultation_fee = obj.consultation_fee;
                session.session_name = obj.session_name;
               

                if(obj.duration){
                var set_time = obj.duration;
                var hour = set_time.split(':')[0];
                var minutes = set_time.split(':')[1];
                

                if (hour != '00') {
                    session.time_name = hour + ' Hr ' + minutes + ' min ';
                } else {
                    session.time_name = minutes + ' min ';
                }
               }
                //console.log(consultation)

                //console.log(consultation[index])

                var index = parseInt(obj.day_id) - 1;
                consultation[index].day.push(session);

                var schedule = {};
                schedule.day = obj.day_id;
                schedule.start = moment.utc('2002-02-02 ' + obj.start_time).format('HH:mm:ss');
                schedule.end = moment.utc('2002-02-02 ' + obj.end_time).format('HH:mm:ss');
                schedule.session_id = obj.doctor_schedule_session_id;
                schedule.duration = obj.duration;
                schedule.token_type = obj.token_type;
                schedule.doctor_id = obj.doctor_id;
                schedule.consultation_fee = obj.consultation_fee;
                schedule.master_session_id = obj.master_session_id;
                schedules.push(schedule);
            });

            this.clinic_consultation = consultation;
            this.clinic_schedules = schedules;
            //console.log('sessionsin :', this.clinic_schedules);

        },

        durationCheck(day){

         let startingTime = moment(this.start, 'HH:mm');
         let endingTime = moment(this.end, 'HH:mm');

         let schedule_duration = moment.duration(endingTime.diff(startingTime)).asMinutes();
         let reserved_duration = moment.duration(this.duration).asMinutes();

         if (reserved_duration > schedule_duration) {
            this.$swal("", "Consultation duration is greater than slot duration!", "error");
         } else {
            this.sessionCheck(day);
         }

        },

        sessionCheck(day) {
            this.getToken();          
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
         
            let formData = new FormData();
            formData.append("start_time", this.start); 
            formData.append("end_time", this.end); 
            formData.append("duration", this.duration); 
            formData.append("reserved", this.token_type); 
            formData.append("day_id", day+1); 
            formData.append("doctor_id", this.$route.params.id); 
             formData.append("master_session_id", this.master_session_id); 

            let url = "clinic/doctors/schedules/sessionCheck"; 
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  // console.log(response);
                  if (response.data.status) {
                     this.addSession(day);
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
            })
            .catch((error) => {
                  if (error.response) {
                     console.log(error.response);
                     if(error.response.status == 400) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                           this.$swal("", "Something went wrong", "error");
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false)); 
         },

         addSession(day) {

            this.day = day;
            
            var datetime1 = '2002-02-02 ' + this.start;
            var start = moment.utc(datetime1).format('hh:mm A');
            var datetime2 = '2002-02-02 ' + this.end;
            var end = moment.utc(datetime2).format('hh:mm A');

            if(this.start > this.end) {
               this.$swal("", "Invalid time slot", "error");
               return;
            }
      

            /////////////////
            //Checking if slot time already present in any of the consultation types starts
            
            var invalid = false;           

            console.log("data:", this.clinic_consultation);
            Object.entries(this.clinic_consultation).forEach(([key,val]) => {
               if(key == this.day) {
                  for(var i=0; i<val['day'].length; i++) {
                     var formattedStartTime = moment(val['day'][i].start, 'hh:mm A').format('HH:mm:ss');
                     var formattedEndTime = moment(val['day'][i].end, 'hh:mm A').format('HH:mm:ss');

                     var newstart =  this.start + ":00";
                     var newend =  this.end + ":00";
                     let newStartTime = moment(newstart, 'HH:mm:ss');
                     let newEndTime = moment(newend, 'HH:mm:ss');
                     let existingStartTime = moment(formattedStartTime, 'HH:mm:ss');
                     let existingEndTime = moment(formattedEndTime, 'HH:mm:ss');

                     // Compare using moment's methods for time comparison
                     if (
                        (newStartTime.isAfter(existingStartTime) && newStartTime.isBefore(existingEndTime)) || // New start is inside existing slot
                        (newEndTime.isAfter(existingStartTime) && newEndTime.isBefore(existingEndTime)) ||     // New end is inside existing slot
                        (existingStartTime.isAfter(newStartTime) && existingStartTime.isBefore(newEndTime)) || // Existing start is inside new slot
                        (newStartTime.isSame(existingStartTime) && newEndTime.isSame(existingEndTime))         // Exact same time slots
                     ) {
                        invalid = true;
                        console.log('Overlap detected');
                        break;
                     }
                  }
               }
            });
            
            //Checking if slot time already present in any of the consultation types ends
            /////////////////
            

               Object.entries(this.clinic_consultation).forEach(([key,val]) => {
                  if(key == this.day) {
                     if(!invalid) {
                        val['day'].push({start: this.start + ':00', end: this.end + ':00', day: this.day + 1,time_name: this.duration + ':00', token_type: this.token_type, consultation_fee: this.clinic.fees, session_name: this.session_name, master_session_id: this.master_session_id});
                        this.clinic_schedules.push({day: this.day + 1, start: start, end: end, duration: this.duration, token_type: this.token_type, consultation_fee: this.consultation_fee, master_session_id: this.master_session_id});
                     } else {
                        this.$swal("", "Time already included in clinic consultation", "error");
                     }
                  }
               });
            
            this.clearSession();
            this.$refs['session-modal'].hide();
         },

         clearSession() {
            this.start = '';
            this.end = '';
            this.day = null;
            this.token_type = '';
            this.reserved = 2;
            this.pin_no = '';
            this.masterStart= ''; 
            this.masterEnd= '';
            this.master_session_id = '';
            this.session_name = '';
            this.master_session_value = '';

         },


         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },
         handleFormSubmit() {
            this.showModal("pin-modal");
         },
         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         },

         checkPin() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/check_pin_no";

            let formData = new FormData();
            formData.append("pin_no", this.pin_no);
            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     // this.$swal("", response.data.message, "success");
                     this.hideModal('pin-modal');
                     this.addClinicSchedule();
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                        this.$swal("", error.response.data.message, "error");

                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         }, 

         isSessionAddable(day) {
            //alert("day: " + day + ", type: " + type);
            this.day = day;

            this.getToken();          
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            var count = 0;
            count = this.clinic_consultation[day].day.length;

            let formData = new FormData();
            formData.append("doctor_id", this.$route.params.id); 
            formData.append("day", day + 1); 
            formData.append("count", count);                         

            let url = "clinic/doctors/schedules/isSLotAddable2"; 
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  // console.log(response);
                  if (response.data.status) {
                     this.showModal('session-modal');
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
            })
            .catch((error) => {
                  if (error.response) {
                     console.log(error.response);
                     if(error.response.status == 400) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        if (error.response.data.message) {
                           //this.errors = error.response.data.message;
                           //console.log(this.errors);
                           this.$swal("", "Something went wrong", "error");
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false)); 
         },

         removeSession(obj, index) {

            var session = obj[index];

            this.getToken();
            const config = {
                headers: {
                    "Accept": "application/json",
                    "Authorization": "Bearer " + this.token,
                },
            };



            let formData = new FormData();
            formData.append("doctor_id", this.$route.params.id); 
            formData.append("day_id", session.day); 
            formData.append("start_time", session.start); 
            formData.append("end_time", session.end); 

            let url = "clinic/doctors/schedules/isDeletable"; 
            this.$axios
                .post(url, formData, config)
                .then((response) => {
                    //console.log(response);
                    if (response.data.status) {
                        var start = moment.utc('2002-02-02 ' + session.start).format('HH:mm:ss');
                        var end = moment.utc('2002-02-02 ' + session.end).format('HH:mm:ss');

                        if(session.session_id) {
                           this.clinic_del_session_ids.push(session.session_id);
                           //console.log(this.clinic_del_session_ids); 
                        }

                        this.clinic_schedules.forEach(clinic => {                  
                           if(session.day == clinic.day && 
                              start == clinic.start && 
                              end == clinic.end) {
                              this.clinic_schedules.splice(this.clinic_schedules.indexOf(clinic), 1);
                           }
                        });

                        obj.splice(index, 1);

                    } else {
                        this.$swal("", response.data.message, "error");
                    }

                })
                .catch((error) => {
                    if (error.response) {
                        console.log(error.response);
                        if (error.response.status == 400) {
                            this.$swal("", error.response.data.message, "error");
                        } else {
                            if (error.response.data.message) {
                                //this.errors = error.response.data.message;
                                //console.log(this.errors);
                                this.$swal("", "Something went wrong", "error");
                            } else {
                                this.$swal("", "Something went wrong", "error");
                            }
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));
         }, 

         // geolocate() {
         //    navigator.geolocation.getCurrentPosition((position) => {
         //       this.clinic_marker.position = {
         //         lat: position.coords.latitude,
         //         lng: position.coords.longitude,
         //       };
         //       this.panToMarker();
     //        });
      //    },

         


         //sets the position of marker when dragged
         homeHandleMarkerDrag(e) {
            this.clinic_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
         },

         //Moves the map view port to marker
         homePanToMarker() {
            this.$refs.homeMapRef.panTo(this.clinic_marker.position);
            this.$refs.homeMapRef.setZoom(18);
         },

         //Moves the marker to click position on the map
         homeHandleMapClick(e) {
            this.home_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            console.log(e);
         },     

         homeSetPlace(place) {
            this.home_current_place = place;
            if(this.home_current_place) {
               const marker = {
                  lat: this.home_current_place.geometry.location.lat(),
                  lng: this.home_current_place.geometry.location.lng(),
               };
               this.home_center = marker;
               this.home_marker.position = marker;
               this.home_location = place.formatted_address;
            }
         },
      }
   }
</script>

<style type="text/css">
   .schedules table td {
      padding: 10px;
   }

   .schedules table td .row {
      padding: 0;
   }
</style>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">

                        <!-- <router-link :to="{ name: 'doctors' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link> -->
                        <!-- <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a> -->
                        <a href="#" @click.prevent="goBack" class="btn btn-primary float-end">
                           <i class='bx bx-chevrons-left'></i> Back
                        </a>

                     </div>
                  </div>
                  <!----- top button area ends---->                  

                  
                  <!------ Video Consultation starts ----------> 
                  <b-card header-class="bg-transparent border-light" class="border border-light schedules clinic-schedules">     
                  <!-- <form @submit.prevent="addClinicSchedule()">                     -->
                     <form @submit.prevent="handleFormSubmit()">                    
                     <h5 class="card-title mb-4">
                        <!-- Clinic Consultation                            -->
                        <!-- <div class="form-check form-switch float-end">
                           <input class="form-check-input" type="checkbox"  v-model="clinic_consultation_checked"/>
                        </div> -->
                     </h5> 
                     <ul class="reservervation-defs">
                        <li><i class="fas fa-square reserved-color"></i> Both</li>
                        <li><i class="fas fa-square not-reserved-color"></i> Token Vending Machine Only</li>
                     </ul>                     
                     <div class="row m-0" style="clear:both;" >
                        <div class="col-md-6 col-lg-7 col-xl-7">
                           <label>Session Timings <span class="text-danger">*</span></label>

                           <div class="table-responsive">
                                    
                              <table class="table table-bordered w-100">

                                 <!---- Monday starts-------->
                                 <tr>                                      
                                    <td scope="row">Mon</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-bind:class="{ 'reserved': session.token_type == 1 }" v-for="(session, index) in clinic_consultation[0].day" :key="index">
                                                <p>{{ session.start}} - {{ session.end }} | {{session.time_name}} | {{session.session_name}}<span @click="removeSession(clinic_consultation[0].day, index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">      
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(0, 'clinic')"><i class="fas fa-plus-circle"></i></b-button>              
                                             <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=0, type='clinic'"><i class="fas fa-plus-circle"></i></b-button>-->
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Monday ends -------->

                                 <!---- Tuesday starts-------->
                                 <tr>
                                    <td>Tue</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-bind:class="{ 'reserved': session.token_type == 1 }" v-for="(session, index) in clinic_consultation[1].day" :key="index">
                                                <p>{{ session.start }} - {{ session.end }} | {{session.time_name}} | {{session.session_name}}<span @click="removeSession(clinic_consultation[1].day, index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">   
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(1, 'clinic')"><i class="fas fa-plus-circle"></i></b-button>                               
                                             <!-- <b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=1, type='clinic'"><i class="fas fa-plus-circle"></i></b-button>-->
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Tuesday ends-------->

                                 <!---- Wednesday starts-------->
                                 <tr>
                                    <td>Wed</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-bind:class="{ 'reserved': session.token_type == 1 }" v-for="(session, index) in clinic_consultation[2].day" :key="index">
                                                <p>{{ session.start }} - {{ session.end }} | {{session.time_name}} | {{session.session_name}}<span @click="removeSession(clinic_consultation[2].day, index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                    
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(2, 'clinic')"><i class="fas fa-plus-circle"></i></b-button>                               
                                             <!--<b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=2, type='clinic'"><i class="fas fa-plus-circle"></i></b-button>-->
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Wednesday starts-------->

                                 <!---- Thursday starts-------->
                                 <tr>
                                    <td>Thu</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-bind:class="{ 'reserved': session.token_type == 1 }" v-for="(session, index) in clinic_consultation[3].day" :key="index">
                                                <p>{{ session.start }} - {{ session.end }} | {{session.time_name}} | {{session.session_name}}<span @click="removeSession(clinic_consultation[3].day, index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">    
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(3, 'clinic')"><i class="fas fa-plus-circle"></i></b-button>                                               
                                             <!--<b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=3, type='clinic'"><i class="fas fa-plus-circle"></i></b-button>-->
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Thursday starts-------->

                                 <!---- Friday starts-------->
                                 <tr>
                                    <td>Fri</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-bind:class="{ 'reserved': session.token_type == 1 }" v-for="(session, index) in clinic_consultation[4].day" :key="index">
                                                <p>{{ session.start }} - {{ session.end }} | {{session.time_name}} | {{session.session_name}}<span @click="removeSession(clinic_consultation[4].day, index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                    
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(4, 'clinic')"><i class="fas fa-plus-circle"></i></b-button>                                               
                                             <!--<b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=4, type='clinic'"><i class="fas fa-plus-circle"></i></b-button>-->
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Friday starts-------->

                                 <!---- Saturday starts-------->
                                 <tr>
                                    <td>Sat</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-bind:class="{ 'reserved': session.token_type == 1 }" v-for="(session, index) in clinic_consultation[5].day" :key="index">
                                                <p>{{ session.start }} - {{ session.end }} | {{session.time_name}} | {{session.session_name}}<span @click="removeSession(clinic_consultation[5].day, index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                   
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(5, 'clinic')"><i class="fas fa-plus-circle"></i></b-button>                                                
                                             <!--<b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=5, type='clinic'"><i class="fas fa-plus-circle"></i></b-button>-->
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Saturday ends-------->

                                 <!---- Sunday starts-------->
                                 <tr>
                                    <td>Sun</td>
                                    <td>
                                       <div class="row m-0">
                                          <div class="col-lg-10">
                                             <div class="input-tag" v-bind:class="{ 'reserved': session.token_type == 1 }" v-for="(session, index) in clinic_consultation[6].day" :key="index">
                                                <p>{{ session.start }} - {{ session.end }} | {{session.time_name}} | {{session.session_name}}<span @click="removeSession(clinic_consultation[6].day, index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                             </div>
                                          </div>
                                          <div class="col-lg-2">                    
                                             <b-button variant="success" class="btn-sm" @click="isSessionAddable(6, 'clinic')"><i class="fas fa-plus-circle"></i></b-button>                                                
                                             <!--<b-button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=6, type='clinic'"><i class="fas fa-plus-circle"></i></b-button>-->
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <!---- Sunday ends-------->

                              </table>
                           </div>
                        </div>
                        <div class="col-md-6 col-lg-5 col-xl-5 consultation-details">
                           <!-- <div class="form-group">
                              <label>Consultation Duration <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="clinic.duration">
                                 <option value="" v-if="!clinic.duration">Select</option>
                                 <option value="1">5 minutes</option>
                                 <option value="2">10 minutes</option>
                                 <option value="3">15 minutes</option>
                                 <option value="4">30 minutes</option>
                                 <option value="5">1 hour</option>
                              </select>
                           </div>    -->

                           <div class="form-group">
                              <label>Consultation Fee (in Rs.) <span class="text-danger">*</span></label>
                              <input type="text" class="form-control" v-model="clinic_fees" v-bind:class="{ 'is-invalid': Boolean(errors.consultation_fee) }"/>
                              <div v-for="(val, index) in errors.consultation_fee" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>   

                           <!-- <div class="form-group">
                              <label>Clinic <span class="text-danger">*</span></label>
                              <select class="form-control">
                                    <option value="">Select</option>
                                    <option value="1">Clinic 1</option>
                                    <option value="2">Clinic 2</option>
                                    <option value="3">Clinic 3</option>
                                    <option value="4">Clinic 5</option>
                                    <option value="5">Clinic 5</option>
                              </select>
                           </div> -->

                        </div>


                        <div class="col-12 my-2">
                           <div class="page-loader" v-if="!loading">
                              <button type="submit" class="btn btn-primary">Submit</button>
                           </div>
                           <div class="page-loader" v-else>
                              <img src="@/assets/images/preloaderspin.gif"/>
                           </div>
                        </div>
                     </div>
                     <!-- <div class="row" v-else>
                        <div class="col-12">
                           <p>Not scheduled</p>
                        </div>
                     </div>    -->
                     
                  </form>         
                  </b-card>
                  <!------ Video Consultation ends ---------->                          
                 

               </div>
            </div>
         </div>
      </div>

         <!---- modal starts ---->
               <!---- modal starts ---->
               <b-modal ref="session-modal" id="session-modal" title="Add Session" hide-footer @hidden="clearSession()">
            <!-- <b-form @submit.prevent="addSession(day)">     -->
               <b-form @submit.prevent="durationCheck(day)">    

               <!-- <div class="form-group" v-if="type=='clinic'">
                  <label>Clinic <span class="text-danger">*</span></label>
                  <b-form-select v-model="clinic_id" :options="clinics" class="form-control" @change="setClinicName"></b-form-select>
               </div>                     -->

               <div class="form-group">
                  <label>Session <span class="text-danger">*</span></label>
                  <select class="form-control" v-model="master_session_value"  @change="SetTimeRange()"  v-bind:class="{ 'is-invalid': Boolean(errors.master_session_id) }" >
                     <option value="" v-if="!master_session_value">Select</option>
                     <option :value="{ id: master_session.id, session_name: master_session.session_name,master_start: master_session.start_time ,master_end: master_session.end_time }" v-for="master_session in master_sessions" :key="master_session.id">{{master_session.session_name}}</option>
                  </select>
                  <div v-for="(val, index) in errors.master_session_id" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p></div>
               </div> 

                <b-row md="12" class="form-group">
                  <b-col md="6" class="form-group" v-if="master_session_value">
                     <label class="control-label">Session Start<span class="text-danger">*</span></label>
                        <b-form-input id="example-input" v-model="masterStart" type="text" placeholder="HH:mm" readonly></b-form-input>
                  </b-col>              
                  <b-col md="6" class="form-group" v-if="master_session_value">
                     <label class="control-label">Session End<span class="text-danger">*</span></label>
                        <b-form-input id="example-input" v-model="masterEnd" type="text" placeholder="HH:mm"  readonly></b-form-input>
                  </b-col>      
               </b-row>

               <b-col md="12" class="form-group">
                  <label class="control-label">Start Time<span class="text-danger">*</span></label>
                  <!-- <b-form-timepicker v-model="start" locale="en" size="sm"></b-form-timepicker>   -->  
                  <!-- <b-form-input v-model="start" type="time"></b-form-input> -->
                  <b-input-group class="mb-3">
                     <b-form-input id="example-input" v-model="start" type="text" placeholder="HH:mm" v-bind:class="{ 'is-invalid': Boolean(errors.start_time) }" readonly></b-form-input>
                     <b-input-group-append><b-form-timepicker v-model="start" button-only right :show-seconds="false" :locale="'it'" :hour12="false" format="HH:mm" aria-controls="example-input"></b-form-timepicker></b-input-group-append>
                     <div v-for="(val, index) in errors.start_time" :key="index" class="invalid-feedback">
                        <p class="mb-0">{{ val }}</p></div>
                  </b-input-group>
               </b-col>

               <b-col md="12" class="form-group">
                  <label class="control-label">End Time<span class="text-danger">*</span></label>
                  <!-- <b-form-timepicker v-model="end" locale="en" size="sm"></b-form-timepicker> -->
                  <!-- <b-form-input v-model="end" type="time"></b-form-input> -->
                  <b-input-group class="mb-3">
                     <b-form-input id="example-input" v-model="end" type="text" placeholder="HH:mm" v-bind:class="{ 'is-invalid': Boolean(errors.end_time) }" readonly></b-form-input>
                     <b-input-group-append><b-form-timepicker v-model="end" button-only right :show-seconds="false" :locale="'it'" :hour12="false" format="HH:mm" aria-controls="example-input"></b-form-timepicker></b-input-group-append>
                     <div v-for="(val, index) in errors.end_time" :key="index" class="invalid-feedback">
                        <p class="mb-0">{{ val }}</p></div>
                  </b-input-group>

               </b-col>

               <!-- <b-col md="12" class="form-group">
                  <label>Consultation Duration <span class="text-danger">*</span></label>
                
                  <b-form-select v-model="duration_id" :options="durations" class="form-control"></b-form-select>
               </b-col> -->
          

               <!-- <b-col md="12" class="form-group">
                  <label>Reserved For <span class="text-danger">*</span></label>
                  <select class="form-control" v-model="reserved">
                     <option value="1">Token Vending Machine</option>
                     <option value="3">Both </option>
                  </select>
               </b-col> -->
               <b-row md="12" class="form-group">
                
                <b-col md="6" class="form-group">
                   <label>Consultation Duration <span class="text-danger">*</span></label>

                   <b-input-group class="mb-3">
                     <b-form-input id="example-input" v-model="duration" @input="setTime()" type="text" placeholder="HH:mm" readonly v-bind:class="{ 'is-invalid': Boolean(errors.duration) }"></b-form-input>
                     <b-input-group-append>
                        <b-form-timepicker v-model="duration" @input="setTime()" button-only right :show-seconds="false" :locale="'it'" :hour12="false" format="HH:mm" aria-controls="example-input"></b-form-timepicker>
                     </b-input-group-append>
                     <div v-for="(val, index) in errors.duration" :key="index" class="invalid-feedback">
                        <p class="mb-0">{{ val }}</p>
                     </div>
                  </b-input-group>

                  <span class="ms-1"> {{time_name}}</span>
                </b-col>
                <b-col md="6" class="form-group">

                   <label>Reserved For <span class="text-danger">*</span></label>
                      <select class="form-control" v-model="token_type" v-bind:class="{ 'is-invalid': Boolean(errors.reserved) }">
                        <option value="">Select</option>
                         <option value="2">Token Vending Machine</option>
                         <!-- <option value="2">Mobile App</option> -->
                         <option value="1">Both </option>
                      </select>
                      <div v-for="(val, index) in errors.reserved" :key="index" class="invalid-feedback">
                        <p class="mb-0">{{ val }}</p></div>
                </b-col>
             </b-row>
                        
               <b-col md="12">
                  <b-button type="submit" class="me-3" variant="primary">OK</b-button>
                  <b-button class="" variant="light" @click="$bvModal.hide('session-modal')">Cancel</b-button>
               </b-col>

            </b-form>
         </b-modal>
         <!---- modal ends ----->
         <b-modal ref="pin-modal" id="pin-modal" title="" hide-footer @hidden="clearSession()">
         <b-form @submit.prevent="checkPin()">
            <b-row>  
               <b-col lg="12" class="form-group">
                  <label class="control-label">Pin Number<span class="text-danger">*</span></label>
                  <b-form-input v-model="pin_no" @keypress="numbersOnly" autocomplete="off" maxlength="4" v-bind:class="{ 'is-invalid': Boolean(errors.pin_no) }"></b-form-input>

                  <div v-for="(val, index) in errors.pin_no" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p>
                  </div>
               </b-col>  
               
               <b-col lg="12">
                  <b-button type="submit" class="me-3" variant="primary">Submit</b-button>
                  <b-button class="" variant="light" @click="hideModal('pin-modal')">Close</b-button>
               </b-col>
            </b-row>
         </b-form>
      </b-modal>

   </Layout>
</template>
